import React, { useEffect, useState } from 'react';

const ReceiptView = React.forwardRef(({ receipt, team, manager, items }, ref) => {
  const [totalAmount, setTotalAmount] = useState(0)

  useEffect(() => {
    if (ref) {
      ref.current = document.getElementById('printable-area');
    }
  }, [ref]);

  // styles
  const rowStyle = {
    display: 'flex', 
    alignItems: 'center !important', 
    flexWrap: 'wrap', 
    marginRght: '-15px', 
    marginLeft: '-15px'
  }

  return (
    <div className='card receipt-print' id='printable-area'>
      <div className='card-body'>
        <div className='row f-row-in'>
          <div className='col-md-6'>
            <div className='in-logo-container'>
              <img 
                src='http://giveclarity.co/logo.png'
                alt='Clarity'
                className='logo-invoice'
              />
            </div>
            <h4>Clarity for Charities</h4>
          </div>
          <div className='col-md-6'>
            <h1 className='invoice-he-ti'>INVOICE</h1>
          </div>
        </div>

        <div className="row s-row-in">
          <div className="col-md-6 col-in-f">
            <h4>Invoice To: </h4>
            <h5>
              {team.name}
            </h5>
          </div>
          <div className="col-md-6">
            <div className="form-group rd-pad-in">
              <label htmlFor="invoice_number">
                Receipt Number: {receipt.receipt_id}
              </label>
            </div>
            <div className="form-group rd-pad-in">
              <label htmlFor="invoice_date">
                Payment Date: {receipt.payment_date}
              </label>
            </div>
          </div>
        </div>

        <div>
            <table className="in-show-tb mt-3">
              <tr>
                <th className="col-md-4 t-header-one">Item</th>
                <th className="col-md-2 t-header-tw">Unit Cost</th>
                <th className="col-md-2 t-header-tw">Quantity</th>
                <th className="col-md-2 t-header-tw">Tax</th>
                <th className="col-md-2 t-header-tw">Total</th>
              </tr>
              {items.map(item => (
                <tr key={item.name}>
                  <td className="col-md-4 t-header-one">{item.name}</td>
                  <td className="col-md-2 t-header-tw">${parseFloat(item.cost).toFixed(2)}</td>
                  <td className="col-md-2 t-header-tw">{item.quantity}</td>
                  <td className="col-md-2 t-header-tw">{item.tax}</td>
                  <td className="col-md-2 t-header-tw"><strong>${parseFloat(item.total).toFixed(2)} USD</strong></td>
                </tr>
              ))}
            </table>
          </div>

          <div className="row">
            <div className="col-md-9"></div>
            <div className="col-md-3">
              <div className="form-group">
                <div style={{ textAlign: "center" }}>
                  <strong>Total Invoice Amount</strong>
                </div>
                <div style={{ textAlign: "center" }}>
                  <strong>${parseFloat(receipt.amount).toFixed(2)} USD</strong>
                </div>
              </div>
            </div>
          </div>

          <div className="in-show-footer">
            <div className="row">
              <div className="col-md-5">
              </div>
              <div className="col-md-7">
                <div className="in-sh-footer-it w-100">
                  <div>
                    <strong>Disclaimer</strong>
                  </div>
                  <div
                    className="in-sh-footer-de"
                    contenteditable="false"
                    data-placeholder="No terms at the moment..."
                  >
                    Each team using Clarity for Charities is solely responsible for complying with tax regulations 
                    applicable to their respective countries.
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default ReceiptView;